import { IconChevronDownSmallOutline } from '@teamleader/ahoy';
import React, { useCallback, useRef, useState } from 'react';

import Box from '../Box';
import Button, { ButtonProps } from '../Button';
import Popover from '../Popover';

const DropdownButton: React.FC<ButtonProps> = ({ children, ...rest }) => {
  const [isOpen, setIsOpen] = useState(false);
  const ref = useRef<HTMLButtonElement>(null);

  const handleOpenDropdown = useCallback(() => setIsOpen(true), []);
  const handleCloseDropdown = useCallback(() => setIsOpen(false), []);

  return (
    <>
      <Button {...rest} ref={ref} onClick={handleOpenDropdown}>
        <IconChevronDownSmallOutline />
      </Button>
      {ref.current && isOpen && (
        <Popover anchor={ref.current} onEscKeyDown={handleCloseDropdown} onOverlayClick={handleCloseDropdown}>
          <Box element="ul" marginVertical={2}>
            {children}
          </Box>
        </Popover>
      )}
    </>
  );
};

export default DropdownButton;
